export default class Material {
  name?: string;
  ordinal?: number;

  constructor(name: string, ordinal: number) {
    this.name = name;
    this.ordinal = ordinal;
  }
}
